import React from 'react';

const Avatar = ({ name, size = "md", className = "" }) => {
  const initials = name ? name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) : '??';
  
  const sizes = {
    sm: "w-6 h-6 text-[10px]",
    md: "w-9 h-9 text-xs",
    lg: "w-12 h-12 text-sm"
  };

  return (
    <div className={`flex items-center justify-center rounded-full bg-gradient-to-br from-violet-600 to-indigo-700 border border-white/10 text-white font-bold tracking-tighter ${sizes[size]} ${className}`}>
      {initials}
    </div>
  );
};

export default Avatar;